import React, { useState } from 'react';
import { CustomModal, useCustomToast } from '../../../../components';
import { GoodsRequest } from '../../types/goods-response';
import GoodsDetailView from '../Views/GoodsDetailView';
import { useDownloadFilesGoods, useDownloadPDFGoods } from '../../../../hooks';
import { useManageStatus, useManageStatusGoodItemPetition, useUpdateGestorItems, useUpdateGestorStatus } from '../../../../share';
import { useGoodGestorStatusolicitud, useGoodGestorUpdateValidator } from '../../../../utils/validators/good-request/goodGestorUpdateValidator';
import ModalSaveChanges from '../../../../components/ModalSaveChanges/ModalSaveChanges';
import { useAtom } from 'jotai';
import { authAtom } from '../../../../state';

interface GoodsDetailProps {
  isOpen: boolean;
  OnClose: () => void;
  data?: GoodsRequest;
  isLoading?: boolean;
  refetch?: () => void;
  isApproveRequest?: boolean;
  isRequestedItems?: boolean;
}

const GoodsDetailContainer: React.FC<GoodsDetailProps> = ({
  isOpen,
  OnClose,
  data,
  isLoading,
  refetch,
  isApproveRequest,
  isRequestedItems
}) => {

  const [footerLeft, setFooterLeft] = React.useState<React.ReactNode>(null);
  const { mutateAsync, isPending: isPendingFiles } = useDownloadFilesGoods();
  const { mutateAsync: downloadPDF, isPending: isPendingPdf  } = useDownloadPDFGoods();
  
  const { data: goodPetition } = useManageStatus('GoodPetition');
  const { data: goodPetitionItems } = useManageStatusGoodItemPetition();
  const { mutateAsync: updateGestorItems } = useUpdateGestorItems();
  const { mutateAsync: updateGestorStatus } = useUpdateGestorStatus();
  const { showToast } = useCustomToast();
  
  const [isOpenSaveChanges, setiIsOpenSaveChanges] = useState(false)
  const [isResponseOk, setIsResponseOk] = useState(false)
  const [authData] = useAtom(authAtom);
  
  
  const onSaveItems = async (values: any) => {
    const token = localStorage.getItem('auth')
    const tokenToJs = token ? JSON.parse(token).authorization.token : null;

    try {
      const validateStatus = values.items.filter((item: any) => [14, 15, 16].includes(item.status_id));

      if (validateStatus.length === 0) {
        showToast("error", "Porfavor, gestione los estados de los ítems");
        return;
      }
      const response = await updateGestorItems({ body: values, id: data?.id || '', token: tokenToJs });

      if (response.length > 0) {
        showToast("success", "Item actualizado correctamente")
      }

      setIsResponseOk(true)

      if (refetch) {
        refetch();
      }
      onReset();
    } catch (error) {
      setIsResponseOk(false)
      showToast("error", "Error al actualizar los ítems del gestor")
    }
  };

  const formik = useGoodGestorUpdateValidator({ onSubmit: onSaveItems });
  const onSaveSolicitudGeneral = async (values: any) => {
    const token = localStorage.getItem('auth')
    const tokenToJs = token ? JSON.parse(token).authorization.token : null

    const body = {
      status_id: values.status_id,
      reason: values.reason,
      approved_by: values.approved_by,
    };
    try {
      await updateGestorStatus({ body, token: tokenToJs, id: Number(data?.id) });
      showToast("success", "Item actualizado correctamente")
     
      if (refetch) {
        refetch();
      }
      setIsResponseOk(true)
      onReset();
    } catch (error: any) {
      if (error.response.statusText === "Forbidden") {
        showToast('error', 'No tienes Autorizacion')
      } 
    }
  };
  const formikSolicitud = useGoodGestorStatusolicitud({ onSubmit: onSaveSolicitudGeneral })

  const closeAndReset = () => {
    formik.resetForm()
    formikSolicitud.resetForm()
    OnClose()
  }
  const closeModalSaveChanges = () => {
    setiIsOpenSaveChanges(false);
    formikSolicitud.resetForm()
    formik.resetForm()
  }
  const onReset = () => {
    closeModalSaveChanges();
    setTimeout(() => {
      OnClose();
    }, 100);
  };

  const confirmSaveChanges = async () => {
    try {
      if (data?.can_manage_user) {
        await onSaveItems(formik.values);
      } else  {
        await onSaveSolicitudGeneral(formikSolicitud.values);
      }
    } catch (error: any) {
      showToast('error', String(error?.message) || 'Error al aprobar la solicitud');
    } finally {
      if (refetch) {
        refetch(); 
      }
    }
  };

  const validateAndOpenModalApprove = async () => {
    await formikSolicitud.setValues({
      ...formikSolicitud.values,
      reason: formik.values.reason || 'Sin registro',
      approved_by: Number(authData?.user.id),
    });
    const errors = await formikSolicitud.validateForm(); // Ejecuta la validación manualmente
    formikSolicitud.setTouched(
      Object.keys(formikSolicitud.values).reduce(
        (acc: Record<string, boolean>, key) => {
          acc[key] = true;
          return acc;
        },
        {} as Record<string, boolean> // Tipo del objeto inicial
      )
    );

    if (Object.keys(errors).length === 0) {
      setiIsOpenSaveChanges(true);
    } else {
      console.error("error: missing fields", errors)
    }
  };
  const validateAndOpenModal = async () => {
    await formik.setValues({
      ...formik.values,
      reason: formik.values.reason || 'Sin registro',
    });
    setiIsOpenSaveChanges(true);
  };

  const showManageActions =
    (data?.can_manage && isApproveRequest) ||
    (Number(data?.status_id) === 72 && !isRequestedItems);

  return (
    <CustomModal
      title={`Detalle solicitud de bienes - ${data?.ticket || ''}`}
      open={isOpen}
      onCancel={closeAndReset}
      width="95vw"
      isLoading={isLoading}
      footerLeft={footerLeft}
      onSave={data?.can_manage ?  validateAndOpenModalApprove : validateAndOpenModal }
      labelCancel={showManageActions ? "Cancelar": 'Finalizar' }
      labelSubmit={showManageActions ? "Guardar solicitud": '' }
    >
      <GoodsDetailView
        detailData={data}
        setFooterLeft={setFooterLeft}
        onDocuments={mutateAsync}
        onDownloadPDf={downloadPDF}
        goodStates={goodPetition}
        goodPetitionItems={goodPetitionItems}
        formik={formik}
        onSaveGestor={formik.handleSubmit}
        setIsResponseOk={setIsResponseOk}
        formikSolicitud={formikSolicitud}
        isResponseOk={isResponseOk}
        isApproveRequest={isApproveRequest}
        isPendingFiles={isPendingFiles}
        isPendingPdf={isPendingPdf}
        isRequestedItems={isRequestedItems}
      />
      <ModalSaveChanges
        title="Guardar cambios"
        textOne="¿Está seguro de gestionar esta solicitud de bienes?"
        open={isOpenSaveChanges}
        width={900}
        isLoadingSave={false}
        onClose={() => setiIsOpenSaveChanges(false)}
        labelSubmit="Aceptar"
        onSave={confirmSaveChanges}
      />
    </CustomModal>
  );
};

export default GoodsDetailContainer;
